export default __webpack_public_path__ + "static/media/technicalExcellence_icon.9216fa2f.webp";